import React from 'react';

class Titles extends React.Component {
    render () {
        return (
            <div>
                {/* <h1>Back-Office</h1> */}
            </div>
        );
    }
};

export default Titles;


// WEBPACK FOOTER //
// ./src/components/Titles.js